import PermissionsIcon from '@/shared/assets/icons/key.svg';
import UserAdminIcon from '@/shared/assets/icons/UserAdminIcon.svg';
import FramedUser from '@/shared/assets/icons/FramedUser.svg';
import RolesIcon from '@/shared/assets/icons/briefcase.svg';
import DepartmentsIcon from '@/shared/assets/icons/people-group.svg';
import BranchesIcon from '@/shared/assets/icons/building.svg';
import FunctionalActivitiesIcon from '@/shared/assets/icons/FunctionalActivities.svg';
import { MenuItem } from '@/shared/lib';

export const ADMIN_MENU_ITEMS: MenuItem[] = [
  {
    icon: PermissionsIcon,
    alt: 'Permissões',
    text: 'Permissões',
    routeName: 'AdminPermissoes',
    route: '/admin/permissoes/permissoes',
    permissions: [{ action: 'managePermissions', subject: 'Admin' }],
  },
  {
    icon: UserAdminIcon,
    alt: 'Usuários',
    text: 'Usuários',
    routeName: 'AdminUsuarios',
    route: '/admin/usuarios',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
  {
    icon: FramedUser,
    alt: 'Membros',
    text: 'Membros',
    routeName: 'AdminMembros',
    route: '/admin/membros',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
  {
    icon: RolesIcon,
    alt: 'Cargos',
    text: 'Cargos',
    routeName: 'AdminCargos',
    route: '/admin/cargos',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
  {
    icon: DepartmentsIcon,
    alt: 'Departamentos',
    text: 'Departamentos',
    routeName: 'AdminDepartamentos',
    route: '/admin/departamentos',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
  {
    icon: BranchesIcon,
    alt: 'Filiais',
    text: 'Filiais',
    routeName: 'AdminFiliais',
    route: '/admin/filiais',
    permissions: [{ action: 'manageBranches', subject: 'Admin' }],
  },
  {
    icon: FunctionalActivitiesIcon,
    alt: 'Atividades Funcionais',
    text: 'Atividades Funcionais',
    routeName: 'AdminAtividadesFuncionais',
    route: '/admin/atividades-funcionais',
    permissions: [{ action: 'read', subject: 'Admin' }],
  }
];
